import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { ChatMessageJSONAModel } from "../interfaces/jsona-models/ChatMessageJSONAModel";

export class ChatMessageSelector extends BaseApiSelector<ChatMessageJSONAModel> {
  constructor() {
    super(ResourceType.ChatMessage);
  }
}
